import React from 'react';

import { useDetectClickOutsideElement } from '../../../hooks/useDetectClickOutsideElement';

const ModalPlanRules = ({ isModalPlanRulesActive, closeModalPlanRules, productCoverage }) => {
  if (!isModalPlanRulesActive) return <div />;

  const { containerRef } = useDetectClickOutsideElement({ onClickOutside: closeModalPlanRules });

  return (
    <div className="comp_modalpagamento mobile-roof">
      <div className="modalcontents mobile-modal" ref={containerRef}>
        <div className="contents">
          <div className="modaltop">
            <div className="title">Informações e Regras do Plano</div>
            <div onClick={closeModalPlanRules} className="close-btn">
              <img src="/assets/images/icons/close.svg" alt="botão de fechar janela" style={{ height: '14px' }} />
            </div>
          </div>
          <div className="modalmiddle">
            <p className="modaltable">
              <div className="tableheader">Observações e Restrições</div>
              <div className="modal-text-box">
                <span>
                  {productCoverage.description
                    ? productCoverage.description
                    : 'Leia as condições gerais para conferir as inclusões e exclusões deste plano de seguro.'}
                </span>
              </div>

              <div className="modal-text-box">
                <a href={productCoverage.terms_url} target="_blank" rel="noopener noreferrer">
                  Ver condições gerais
                </a>
              </div>

              <div className="tableheader title">
                <span>Prazos e regras</span>
                <span>Remarcação ou Alteração</span>
              </div>

              <div className="modal-text-box">
                <span>
                  A{' '}
                  <u>
                    solicitação para alteração ou remarcação das datas e/ou destino deve ser realizada antes do início
                    da vigência
                  </u>
                  , ou seja, até um dia antes da data de início da cobertura contratada. Haverá cobrança da diferença de
                  tarifa e câmbio, se houver.
                </span>
              </div>

              <div className="tableheader">Cancelamento com crédito</div>
              <div className="modal-text-box">
                <span>
                  Desde que antes da vigência, o cancelamento com crédito integral pode ser solicitado a qualquer
                  momento após a aprovação do pedido.
                </span>
              </div>

              <div className="tableheader">Cancelamento com reembolso</div>
              <div className="modal-text-box">
                <span>
                  Em <u>até 7 dias após a compra</u> o reembolso será integral.
                </span>
                <span>
                  Após o prazo de 7 dias, <u>haverá a aplicação de multa de R$50,00 ou 20% do valor total da compra</u>,
                  que será descontado do valor a ser reembolsado.
                </span>
                <span className="aviso">
                  <strong>
                    Lembrando que todas as solicitações de cancelamento ou alteração, independente da data da compra, só
                    serão realizadas desde que a solicitação ocorra antes da vigência do seguro.
                  </strong>
                </span>
              </div>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalPlanRules;



// WEBPACK FOOTER //
// ./src/components/purchase/modal_plans_rules/ModalPlansRules.jsx